import { Col, Form, Row } from "react-bootstrap";

const InputFormSampleList = ({
  label,
  placeholder,
  id,
  disabled,
  hidden,
  filter,
  list,
  value = "",
  handleChange,
  required,
  isInvalid,
}) => {
  return (
    <Row className="mb-2" hidden={hidden(filter, label)}>
      <Col xs={12} md={5}>
        <Form.Label
          hidden={hidden(filter, label)}
          style={{ fontSize: "0.875rem" }}
        >
          {label}
        </Form.Label>
      </Col>
      <Col xs={12} md={7}>
        <Form.Select
          required={required}
          placeholder={placeholder}
          id={id}
          disabled={disabled()}
          value={required && (value === null || value === undefined) ? "" : (value ?? "")}
          hidden={hidden(filter, label)}
          onChange={(e) => handleChange(id, e.target.value === "" ? null : e.target.value)}
          size="sm"
          isInvalid={isInvalid}
        >
          <option value="">-Seleccionar-</option>
          {list !== undefined &&
            list.length > 0 &&
            list
              .filter((field) => field !== null && field !== "")
              .map((field, index) => (
                <option key={index} value={field}>
                  {field}
                </option>
              ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          El {label} es necesario.
        </Form.Control.Feedback>
      </Col>
    </Row>
  );
};

export default InputFormSampleList;
